// src/components/common/RateUser.jsx
import { useState } from 'react';
import { Star } from 'lucide-react';
import api from '../../lib/api';
import { success, error } from '../../components/common/Toast';

const RateUser = ({ 
  userId, 
  initialRating = 0,     // current rating (if already rated)
  disabled = false,      // prevent re-rating
  size = 'md',           // 'sm', 'md', 'lg'
  showNumber = true,
  onRated,               // optional callback
  className = ''
}) => {
  const [rating, setRating] = useState(initialRating);
  const [hovered, setHovered] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleClick = async (value) => {
    if (disabled || loading) return;

    setLoading(true);
    try {
      await api.post(`/profile/${userId}`, { rating: value });
      setRating(value);
      success('Thank you for your rating!');
      if (onRated) onRated(value);
    } catch (err) {
      error('Failed to submit rating');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const starSize = {
    sm: 'w-5 h-5',
    md: 'w-7 h-7',
    lg: 'w-10 h-10'
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {[1, 2, 3, 4, 5].map((star) => {
        const isFilled = star <= (hovered || rating);
        return (
          <button
            key={star}
            type="button"
            onClick={() => handleClick(star)}
            onMouseEnter={() => setHovered(star)}
            onMouseLeave={() => setHovered(0)}
            disabled={disabled || loading}
            className={`
              transition-all duration-200 
              ${disabled || loading ? 'cursor-not-allowed opacity-60' : 'cursor-pointer hover:scale-110'}
            `}
          >
            <Star
              className={`
                ${isFilled ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}
                ${starSize[size]}
              `}
            />
          </button>
        );
      })}

      {showNumber && (
        <span className="ml-3 font-bold text-gray-700">
            {rating > 0 ? rating?.toFixed(1) : ''}
        </span>
      )}

      {loading && (
        <span className="ml-3 text-sm text-gray-500">Submitting...</span>
      )}
    </div>
  );
};

export default RateUser;